'use client';

import { useSelector } from 'react-redux';
import { BookingHistory } from '../../components';
import { LayoutContainer } from '../../kit';
import { useTranslation } from '../../kit/useTranslation';

export default function HistoryPage() {
  const { loading, error } = useSelector((state) => state.booking);
  const { t } = useTranslation();

  return (
    <LayoutContainer>
      {loading && (
        <div style={{ textAlign: 'center', margin: '32px 0' }}>{t('common.loading')}</div>
      )}
      {error && <div style={{ color: 'red', textAlign: 'center', margin: '32px 0' }}>{error}</div>}
      <BookingHistory />
    </LayoutContainer>
  );
}
